import TabItem from './TabItem'
import PropTypes from 'prop-types'
import React, { Children, Component, cloneElement } from 'react'

export default class TabList extends Component {
  static propTypes = {
    children: PropTypes.oneOfType([PropTypes.array, PropTypes.element])
      .isRequired,
    location: PropTypes.object,
    tabActive: PropTypes.number
  }

  static defaultProps = {
    tabActive: 1
  }

  constructor(props) {
    super(props)

    this.state = {
      tabActive: this.props.tabActive
    }
  }

  isActive(child, tabNumber) {
    const { location } = this.props
    const { href } = child.props

    if (location && href) {
      return href === location.pathname
    }

    return this.state.tabActive === tabNumber
  }

  renderTabs() {
    const { children, location } = this.props
    const items = this.getChildren()

    if (process.NODE_ENV !== 'production') {
      if (!children) {
        throw new Error('TabList must contain at least one TabPanel')
      }

      if (items.some(item => item.href) && !location) {
        throw new Error('TabList must include location to use with routing')
      }
    }

    return items.map((child, index) => (
      <TabItem
        key={index}
        onSelect={() => !child.href && this.changeTab(index + 1)}
        isSelected={this.isActive(child, index + 1)}
        title={child.props.title}
        href={child.props.href}
      />
    ))
  }

  changeTab(activeTab) {
    this.setState({ tabActive: activeTab })
  }

  renderPanels() {
    let index = 0
    return Children.map(this.getChildren(), child => {
      index += 1
      return cloneElement(child, {
        isActive: this.isActive(child, index)
      })
    })
  }

  getChildren() {
    if (Array.isArray(this.props.children)) {
      return this.props.children.filter(item => item)
    } else {
      return [this.props.children]
    }
  }

  render() {
    return (
      <div>
        <nav className="qv-tabs">{this.renderTabs()}</nav>
        {this.renderPanels()}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ../src/components/TabList.js